import { SpeakingRole, TurnType, Winner } from '@db8/shared'
import { useMemo } from 'react'

const bgConfigs = {
  Affirmative: {
    bgClass: 'gradient-bg-affirmative',
    borderColor: 'rgba(34, 197, 94, 1)',
  },
  Negative: {
    bgClass: 'gradient-bg-negative',
    borderColor: 'rgba(69, 93, 235, 1)',
  },
  Moderator: {
    bgClass: 'gradient-bg-moderators',
    borderColor: 'rgb(145, 35, 155)',
  },
}

export const useTeamColors = (options: {
  speakingRole?: SpeakingRole | Winner
  turnType?: TurnType
}) => {
  const { speakingRole, turnType } = options

  return useMemo(() => {
    if (turnType) {
      if (turnType === TurnType.Affirmative || turnType === TurnType.AffirmativeCrossNegative)
        return bgConfigs.Affirmative
      if (turnType === TurnType.Negative || turnType === TurnType.NegativeCrossAffirmative)
        return bgConfigs.Negative
      if (turnType === TurnType.Preperatory) return bgConfigs.Moderator
    }

    if (speakingRole === SpeakingRole.Affirmative) return bgConfigs.Affirmative
    if (speakingRole === SpeakingRole.Negative) return bgConfigs.Negative
    // @ts-ignore
    if ([SpeakingRole.Moderator, Winner.Tie].includes(speakingRole)) return bgConfigs.Moderator

    return {
      bgClass: '',
      borderColor: '',
    }
  }, [speakingRole, turnType])
}
